export enum EstrattoMutationType {
  SET_LOADING = 'SET_LOADING',
  SET_ESTRATTO = 'SET_ESTRATTO',
  SET_ESTRATTO_TOTAL = 'SET_ESTRATTO_TOTAL',
  SET_RIEPILOGO = 'SET_RIEPILOGO',
  SET_RIEPILOGO_TOTAL = 'SET_RIEPILOGO_TOTAL',
  SET_DETTAGLIO = 'SET_DETTAGLIO',
  SET_DETTAGLIO_TOTAL = 'SET_DETTAGLIO_TOTAL',
  SET_MATERIALS = 'SET_MATERIALS',
  SET_DATES = 'SET_DATES',
  SET_ORDER_STATEMENT_ID = 'SET_ORDER_STATEMENT_ID'
}
